export default __webpack_public_path__ + "static/media/illustration_texture-pattern-1.0e146cd4.png";